import * as React from 'react';
import {Button} from '@openfin/desktop-ui';

import {ClassNameBuilder} from '../../utils/ClassNameBuilder';

import * as Styles from './OptionSelector.module.scss';

export interface Option {
    key: string;
    label: string;
    data?: any;
}

export interface OptionSelectorProps {
    label: string;
    choices: Option[];
    selectedChoiceKey: string;
    onChange?: (selection: Option) => void;
}

export const OptionSelector: React.FC<OptionSelectorProps> = (props) => {
    const {label, choices, selectedChoiceKey, onChange} = props;

    function select(selection: Option) {
        if (onChange) {
            onChange(selection);
        }
    }

    return (
        <div className={Styles['options-selector']}>
            <p className={Styles['option-label']}>{label}</p>
            <div className={Styles['choice-list']}>
                {choices.map((choice) => {
                    const classNameBuilder = new ClassNameBuilder(Styles, 'selector-choice');
                    let color: React.ComponentProps<typeof Button>['color'] = 'secondary';
                    if (selectedChoiceKey === choice.key) {
                        color = 'primary';
                    }

                    return <Button className={classNameBuilder.toString()} color={color} key={choice.key} onClick={() => select(choice)}>
                        {choice.label}
                    </Button>;
                })}
            </div>
        </div>
    );
};
